module.exports = __webpack_public_path__ + "img/744.1680fb33.jpg";